import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const RedirectByResetPassword: React.FC = () => {
    const navigate = useNavigate(); 
    const [searchParams] = useSearchParams();

    useEffect(() => {   
        const id = searchParams.get('id'); 
        const encodedToken = encodeURIComponent(searchParams.get('token')!);
        navigate(`/recruiter/account/resetPassword?id=${id}&token=${encodedToken}`); // Redirect to the Recruiter Reset password page
    }, []);
    
    return null; // This component doesn't render anything
};